export default __webpack_public_path__ + "static/media/cchp_banner.7f6d651a.svg";